// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__1RrKu","info":"UpdateTermsInfo_info__2jZvF"};